import { makeStyles } from "@material-ui/core";
import { fontFamily } from "../../../../app/theme";

export const useWhyChooseUsStyles = makeStyles((theme) => ({
  root: {
    fontFamily: fontFamily.Axiforma
  },
  Swyft: {
    color: "#f7815c"
  }
}));
